import { ShoppingDataLayerProduct } from '@makro-shopping/use-product-card-logic/dist/types/product.type';
import { Product, ProductSearchResult } from '../types/product.types';
import { BasketItemsPreviewV5, PreviewBasketItemV5 } from '../types/basket.types';
import { VARIANT_ID_PREFIX } from './constants';
import { getProductIdWithoutPrefix } from './product.util';

export const findBasketItemWithPreviewItems = (
  product: Product | ProductSearchResult | ShoppingDataLayerProduct,
  basketItems?: BasketItemsPreviewV5,
): PreviewBasketItemV5 | undefined => {
  const searchProduct = product as ProductSearchResult;
  const regularProduct = product as Product;
  const variantId = regularProduct?.variants?.length ? regularProduct?.variants[0]?.id : searchProduct?.variantId;
  return product && findPreviewBasketItemByVariantOrProductId(basketItems, variantId, product?.id, product);
};

export const getVariantIdWithoutPrefix = (id: string): string => {
  return id.includes(VARIANT_ID_PREFIX) ? id.split(VARIANT_ID_PREFIX).pop() || '' : id;
};

export const isVariantNumeric = (variantId: string) => /^[\d]+$/.test(variantId);

export const parseVariantId = (variantId: string) => {
  return isVariantNumeric(variantId)
    ? variantId
    : getVariantIdWithoutPrefix(Buffer.from(variantId, 'base64').toString());
};

export const findPreviewBasketItemByVariantOrProductId = (
  basketItems?: BasketItemsPreviewV5,
  variantId?: string,
  productId?: string,
  product?: Product | ProductSearchResult | ShoppingDataLayerProduct,
): PreviewBasketItemV5 => {
  const basketItem = basketItems?.find((i: PreviewBasketItemV5) => {
    return (
      (variantId && i?.variantId && parseVariantId(i?.variantId) === parseVariantId(variantId)) ||
      (productId && getProductIdWithoutPrefix(i.id) === getProductIdWithoutPrefix(productId))
    );
  });

  if (basketItem) {
    basketItem.variantId = variantId;
    basketItem.productDetails = product;
    basketItem.productId = getProductIdWithoutPrefix(productId || product?.id || basketItem.id);
    basketItem.quantity = basketItem.quantitySetByUser || basketItem.quantity;
  }
  return basketItem as PreviewBasketItemV5;
};

export const roundOffDecimalQuantity = (decimalQty: number) => {
  // convert to number
  const quantity = Number(decimalQty);

  if (Number.isNaN(quantity)) {
    return decimalQty;
  }

  if (!Number.isInteger(quantity)) {
    return quantity < 1 ? 1 : Math.round(quantity);
  }

  return quantity;
};
